import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCertificate} from '@fortawesome/free-solid-svg-icons'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

export default function TutorProfileQualificationsList({tutorProfile}) {
  const sortedQualifications = tutorProfile.qualifications.sort((a, b) => (
    a.qualificationLevel.position - b.qualificationLevel.position
  ))

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Level</th>
            <th>School</th>
            <th>Subject</th>
            <th>Grade</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {sortedQualifications.map(qualification => (
            <tr key={qualification.id}>
              <td>{qualification.qualificationLevel.name}</td>
              <td>{qualification.schoolName}</td>
              <td>{qualification.subjectName}</td>
              <td>{qualification.grade}</td>
              <td>
                {/*{qualification.hasDocument &&*/}
                {/*  <OverlayTrigger placement="top" overlay={<Tooltip title="Exam certificate verified" />}>*/}
                {/*    <FontAwesomeIcon icon={faCertificate} className="text-success" />*/}
                {/*  </OverlayTrigger>*/}
                {/*}*/}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
